/* Naht & Leinen – Team C: Kollektionen (Sortierung, „Weitere … laden“, Aufklapp-Filter), Suche (Reiter), Sparsets (mobil alle zeigen). */
(function () {
  'use strict';
  if (window.NlShop) return;

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sortierung: Auswahl ändert die Adresse (Filter bleiben, Seite wird zurückgesetzt) */
  function sortierung(root) {
    root.querySelectorAll('[data-nl-sortierung]').forEach(function (wahl) {
      if (wahl.dataset.nlFertig) return;
      wahl.dataset.nlFertig = '1';
      wahl.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.delete('page');
        if (wahl.value) url.searchParams.set('sort_by', wahl.value); else url.searchParams.delete('sort_by');
        window.location.href = url.toString();
      });
    });
  }

  /* Aufklapp-Filter: schließen bei Klick daneben oder Escape */
  function aufklapp(root) {
    var alle = root.querySelectorAll('details[data-nl-aufklapp]');
    alle.forEach(function (d) {
      if (d.dataset.nlFertig) return;
      d.dataset.nlFertig = '1';
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        document.querySelectorAll('details[data-nl-aufklapp][open]').forEach(function (anderes) { if (anderes !== d) anderes.open = false; });
      });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && d.open) { d.open = false; d.querySelector('summary').focus(); }
      });
    });
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-nl-aufklapp][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });

  /* „Weitere Designs laden“: nächste Seite über die Section-Rendering-API holen und anhängen */
  function mehrLaden(root) {
    root.querySelectorAll('[data-nl-raster]').forEach(function (raster) {
      var knopf = raster.querySelector('[data-nl-mehr-knopf]');
      if (!knopf || knopf.dataset.nlFertig || !window.fetch) return;
      knopf.dataset.nlFertig = '1';
      var liste = raster.querySelector('.nl-shop-raster__liste');
      var gezeigt = raster.querySelector('[data-nl-gezeigt]');
      var balken = raster.querySelector('[data-nl-balken]');
      var gesamt = parseInt(knopf.dataset.gesamt, 10) || 0;
      var textNormal = knopf.textContent;

      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        if (knopf.getAttribute('aria-busy') === 'true') return;
        var ziel = new URL(knopf.href, window.location.href);
        ziel.searchParams.set('section_id', raster.dataset.section);
        knopf.setAttribute('aria-busy', 'true');
        knopf.textContent = 'Lädt …';
        fetch(ziel.toString(), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var neu = doc.querySelectorAll('.nl-shop-raster__liste > li');
            var erstes = null;
            neu.forEach(function (li) {
              var kopie = document.importNode(li, true);
              liste.appendChild(kopie);
              if (!erstes) erstes = kopie;
            });
            var anzahl = liste.children.length;
            if (gezeigt) gezeigt.textContent = anzahl;
            if (balken && gesamt) balken.style.width = Math.min(100, Math.round(anzahl * 100 / gesamt)) + '%';
            var weiter = doc.querySelector('[data-nl-mehr-knopf]');
            var zurueck = raster.querySelector('.nl-shop-mehr__zurueck');
            if (zurueck) zurueck.remove();
            if (weiter) {
              knopf.href = weiter.getAttribute('href');
              knopf.textContent = textNormal;
              knopf.removeAttribute('aria-busy');
            } else {
              knopf.remove();
            }
            if (erstes) {
              var link = erstes.querySelector('a');
              if (link) link.focus({ preventScroll: ruhig });
            }
          })
          .catch(function () {
            window.location.href = knopf.href;
          });
      });
    });
  }

  /* Suche: Reiter Produkte / Seiten */
  function reiter(root) {
    root.querySelectorAll('[data-nl-reiter]').forEach(function (leiste) {
      if (leiste.dataset.nlFertig) return;
      leiste.dataset.nlFertig = '1';
      var treffer = document.getElementById(leiste.querySelector('[role="tab"]').getAttribute('aria-controls'));
      var knoepfe = Array.prototype.slice.call(leiste.querySelectorAll('[role="tab"]'));
      function waehlen(knopf, fokus) {
        knoepfe.forEach(function (k) {
          var aktiv = k === knopf;
          k.setAttribute('aria-selected', aktiv ? 'true' : 'false');
          k.tabIndex = aktiv ? 0 : -1;
        });
        if (treffer) {
          treffer.dataset.zustand = knopf.dataset.nlReiterWahl;
          treffer.setAttribute('aria-labelledby', knopf.id);
        }
        if (fokus) knopf.focus();
      }
      knoepfe.forEach(function (k, i) {
        k.addEventListener('click', function () { waehlen(k, false); });
        k.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var naechster = knoepfe[(i + (e.key === 'ArrowRight' ? 1 : knoepfe.length - 1)) % knoepfe.length];
          waehlen(naechster, true);
        });
      });
      if (treffer) treffer.setAttribute('role', 'tabpanel');
      leiste.hidden = false;
      var start = knoepfe.filter(function (k) { return k.getAttribute('aria-selected') === 'true'; })[0] || knoepfe[0];
      waehlen(start, false);
    });
  }

  /* Sparsets mobil: zuerst einige zeigen, Knopf blendet den Rest ein */
  function sets(root) {
    root.querySelectorAll('[data-nl-sets]').forEach(function (liste) {
      var knopf = liste.parentElement.querySelector('[data-nl-sets-alle]');
      if (!knopf || liste.dataset.nlFertig) return;
      liste.dataset.nlFertig = '1';
      liste.classList.add('is-gekuerzt');
      knopf.hidden = false;
      knopf.addEventListener('click', function () {
        liste.classList.remove('is-gekuerzt');
        knopf.setAttribute('aria-expanded', 'true');
        knopf.hidden = true;
        var erstes = liste.querySelector('.nl-shop-set--extra a');
        if (erstes) erstes.focus();
      });
    });
  }

  function start(scope) {
    var s = scope || document;
    sortierung(s);
    aufklapp(s);
    mehrLaden(s);
    reiter(s);
    sets(s);
  }

  window.NlShop = { start: start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
